export const environment = {
    production: false,
    staging: true,
    HOST: 'diagnostics-backend.sennebogen.com',
    PORT: 9443,
    PROTOCOL: 'https://',
    keycloak: {
        url: 'https://login.mysennebogen.com/auth/',
        realm: 'sennebogen-portal',
        clientId: 'diagnostics-client',
    }
};
